export enum SubscriptionRequestType {
  Add = 1,
  Cancel = 2,
  Update = 3,
  Resubscribe = 4,
}
